module.exports = __webpack_public_path__ + "img/logo_copy2.03b1d635.png";